import { render } from "./AssessmentMessages.vue?vue&type=template&id=903a1314&scoped=true"
import script from "./AssessmentMessages.vue?vue&type=script&lang=js"
export * from "./AssessmentMessages.vue?vue&type=script&lang=js"

import "./AssessmentMessages.vue?vue&type=style&index=0&id=903a1314&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903a1314"]])

export default __exports__